import { useState } from 'react'
import { TabPanel, Tabs } from '../../../ui'

export interface tabsProps {
    tabs: {
        title: String
        panel: any
    }[]
    selectedIndex?: number
    onSelect?: (index: number) => void
}

/**
 * Legacy index-based tab block. New code should use `Tabs` from `ui` with
 * string values.
 */
export const TabsBlock = ({ tabs, selectedIndex, onSelect }: tabsProps) => {
    const [internal, setInternal] = useState(0)
    const index = selectedIndex ?? internal
    const items = tabs.map((t, i) => ({ value: String(i), label: String(t.title) }))

    return (
        <div>
            <Tabs
                items={items}
                value={String(index)}
                onChange={(v) => {
                    const next = Number(v)
                    if (selectedIndex == null) setInternal(next)
                    onSelect?.(next)
                }}
            />
            <TabPanel>{tabs[index]?.panel}</TabPanel>
        </div>
    )
}
